
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { TextValue, BlockHeader } from "../Components/Text.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { append, singleton, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { singleton as singleton_1, map as map_2, empty, ofArray, isEmpty } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { MultiSelect } from "../Components/Select.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { map as map_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { Msg } from "./Types.js";
import { TextButton, Button } from "../Components/Button.js";
import { LanguageSelector } from "../Components/I18n.js";
import { EmailNotification } from "../Widgets/EmailNotification.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../Components/Skeleton.js";

function profileBox(children) {
    return reactElement("div", {
        className: join(" ", ["bg-white", "rounded", "px-12", "py-9"]),
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function DashboardSettings(props) {
    let elems;
    const t = useTranslation()[0];
    const toOption = (viewName) => ({
        label: viewName,
        value: viewName,
    });
    return profileBox(ofArray([createElement(BlockHeader, {
        Text: t("profile.dashboard_header"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems = toList(delay(() => (isEmpty(props.SavedViews) ? singleton(createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("dashboard.availability_no_views_hint"),
    })) : append(singleton(createElement(MultiSelect, {
        ComponentState: "enabled",
        IsClearable: true,
        Label: t("dashboard.availability_select_views"),
        NoOptionsMessage: "dashboard.availability_no_views",
        OnChange: (options) => {
            props.Dispatch(new Msg(12, [defaultArg(map((options_1) => ofArray(map_1((_arg) => _arg.value, options_1)), options), empty())]));
        },
        Options: map_2((view) => toOption(view.Name), props.SavedViews),
        PlaceholderKey: "dashboard.availability_select_views",
        TestId: "profile-dashboard-view-select-test-id",
        Value: map_2(toOption, props.DashboardViewNames),
    })), delay(() => {
        let children;
        return singleton((children = singleton_1(createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.save"),
            OnClick: () => {
                props.Dispatch(new Msg(13, []));
            },
            TestId: "profile-dashboard-save-button",
            Variant: "primary",
        })), reactElement("div", {
            children: reactApi.Children.toArray(Array.from(children)),
        })));
    }))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))]));
}

export function ViewContent(props) {
    let elems_4, elems, elems_1, elems_3, elems_2, children, matchValue;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid grid-cols-2 gap-4", "items-start"])], (elems_4 = [profileBox(ofArray([createElement(BlockHeader, {
        Text: t("profile.password_header"),
    }), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("profile.password_reset_description_1"),
    }), createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("profile.password_reset_description_2"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-2"])], (elems = [createElement(TextButton, {
        ComponentState: "enabled",
        Label: t("profile.reset_password"),
        OnClick: () => {
            props.Dispatch(new Msg(0, []));
        },
        TestId: "profile-resetpassword-button",
        Variant: "blueButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))])), profileBox(ofArray([createElement(BlockHeader, {
        Text: t("profile.language_header"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["w-64"])], (elems_1 = [createElement(LanguageSelector, {
        ChangeCallback: (arg) => {
            props.Dispatch(new Msg(1, [arg]));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))])), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_3 = [profileBox(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_2 = [createElement(EmailNotification, {
        FormState: "enabled",
        OnChangeEmailNotification: (arg_1) => {
            props.Dispatch(new Msg(4, [arg_1]));
        },
        OnChangeNewsletterConsent: (arg_2) => {
            props.Dispatch(new Msg(5, [arg_2]));
        },
        User: props.User,
    }), (children = singleton_1(createElement(Button, {
        ComponentState: "enabled",
        Label: t("general.save"),
        OnClick: () => {
            props.Dispatch(new Msg(7, []));
        },
        TestId: "update-email-notification-button",
        Variant: "primary",
    })), reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))))), createElement(DashboardSettings, {
        DashboardViewNames: props.State.DashboardViewNames,
        Dispatch: props.Dispatch,
        SavedViews: (matchValue = props.State.SavedAvailabilityViews, (matchValue.tag === 1) ? empty() : matchValue.fields[0]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function ProfileView(props) {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.TokenDataDto, undefined);
    const state_1 = patternInput[0];
    return reactElement("div", createObj(singleton_1((elems = toList(delay(() => {
        const matchValue = state_1.User;
        const matchValue_1 = state_1.Storages;
        let matchResult, user;
        if (matchValue.tag === 1) {
            if (matchValue_1.tag === 1) {
                matchResult = 0;
            }
            else {
                matchResult = 0;
            }
        }
        else if (matchValue_1.tag === 0) {
            matchResult = 1;
            user = matchValue.fields[0];
        }
        else {
            matchResult = 0;
        }
        switch (matchResult) {
            case 0:
                return singleton(createElement(Skeleton, {
                    Variant: "normal",
                }));
            default:
                return singleton(createElement(ViewContent, {
                    Dispatch: patternInput[1],
                    State: state_1,
                    User: user,
                }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

